import React, {useState, useEffect} from 'react';
import bn from "../utils/bemnames";
import {DateTime, Duration} from 'luxon';

const bem = bn.create('countdown-timer');

interface IProps {
  eventDate: string,
  isMobile: boolean,
  returnPlainText?:boolean
}

const CountdownTimer: React.FC<IProps> = ({eventDate, isMobile, returnPlainText = false}) => {
  const [timer, setTimer] = useState(String);
  const [timeOver, setTimeOver] = useState(false)

  const eventStart = DateTime.fromISO(eventDate)

  useEffect(() => {
    const tick = setInterval(() => {
      let timeNow = DateTime.local().set({millisecond: 0})
      let timeDiff = eventStart.diff(timeNow).toObject();
      let duration = Duration.fromObject(timeDiff);
      setTimer(duration.toFormat('hh:mm:ss'))
      if (duration.milliseconds && duration.milliseconds < 0) {
        clearInterval(tick);
        setTimeOver(true);
      }
    }, 1000)
    //disable lint required to avoid constant refresh if adding eventStart to dependency array
    // eslint-disable-next-line
  }, [eventDate])

  return (
    <>
      {!timeOver && !returnPlainText &&
        (
          <div className={`${bem.e('the-timer')} ${isMobile ? bem.e('the-timer-mobile') : '' }`}>
            {timer}
          </div>
        )
      }
      {!timeOver && returnPlainText && (
        timer
      )}
    </>
  )
}

export default CountdownTimer

